// extracted by mini-css-extract-plugin
export default {"core-exclusive":"_3THxs","coreExclusive":"_3THxs","cta":"_2JR0F"};